export const update = {
  updateSuccessfully: 'Update tank successfully!',
}
